module.exports = __webpack_public_path__ + "static/featured_loop_s-696b6ef8e513b9aa956d8262e97a969a.mp4";